export var EMBEDDED_CONFLUENCE_METRICS_PREFIX = 'embedded-confluence-metrics.';
export var EMBEDDED_VIEW_TTI = 'embedded-view-tti';
export var EMBEDDED_EDITOR_TTI = 'embedded-editor-tti';
export var EMBEDDED_EDIT_CLICK = 'embedded-edit-click';
export var EMBEDDED_IFRAME_CONTENT_INITIALIZED = 'embedded-iframe-content-initialized';